import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './locales/zh-CN'
import fr from './locales/fr'
import en from './locales/en'
import es from './locales/es'
import ar from './locales/ar'

Vue.use(VueI18n)

const saved = localStorage.getItem('bajj_lang')
const sys = (navigator.language || 'en').toLowerCase()

/** Match browser language; Arabic → العربية */
function resolveLocale() {
  if (saved) return saved
  if (sys.startsWith('zh')) return 'zh-CN'
  if (sys.startsWith('ar')) return 'ar'
  if (sys.startsWith('fr')) return 'fr'
  if (sys.startsWith('es')) return 'es'
  if (sys.startsWith('en')) return 'en'
  return 'en'
}

function applyDocumentDir(lang) {
  try {
    const rtl = lang === 'ar'
    document.documentElement.setAttribute('lang', lang === 'zh-CN' ? 'zh-CN' : lang)
    document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr')
  } catch (e) { /* ignore */ }
}

const i18n = new VueI18n({
  locale: resolveLocale(),
  fallbackLocale: 'en',
  messages: { en, fr, es, ar, 'zh-CN': zhCN }
})

applyDocumentDir(i18n.locale)

export function setLocale(lang) {
  i18n.locale = lang
  localStorage.setItem('bajj_lang', lang)
  applyDocumentDir(lang)
}

export default i18n
